// import { Tarifa } from './../../lookups/tarifa/tarifa';
import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, DefgIniService, ModalService, NotificationService } from 'yt-ng-framework';
import { OsnovZaPravoNaGo } from './osnov-za-pravo-na-go';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { OsnovZaPravoNaGoView } from './osnov-za-pravo-na-go-view';
import { Validators } from '@angular/forms';
import * as var_config from '../../var_config';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-osnov-za-pravo-na-go-update',
  templateUrl: './osnov-za-pravo-na-go-update.component.html'
})
export class OsnovZaPravoNaGoUpdateComponent extends BaseUpdateComponent<OsnovZaPravoNaGo> implements OnInit {
  varConfig=var_config;
  minBrDanaGo: number;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected defgIni: DefgIniService,
    protected modalService: ModalService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('OsnovZaGoID', Validators.required, 'required', 'OSNOVZAPRAVONAGO.OSNOVZAGO.VALIDATION.REQUIRED');
    // this.addValidatorToFc('PravoNaGoID', Validators.required, 'required', 'OSNOVZAPRAVONAGO.PRAVONAGO.VALIDATION.REQUIRED');
    this.addValidatorToFc('BrojDana', Validators.required, 'required', 'OSNOVZAPRAVONAGO.BROJDANA.VALIDATION.REQUIRED');
  }

  onOsnovZaPravoNaGoSelect(value:OsnovZaPravoNaGoView){
    if (value && value["GenericName"]=="min" && this.Item.ID==-1 && (this.baseFormGroup.get("BrojDana").value==0 || this.baseFormGroup.get("BrojDana").value==null))
    {
      this.minBrDanaGo = this.defgIni.GetByKey("g_efakture_taster");

      this.baseFormGroup.patchValue({BrojDana: this.minBrDanaGo});
      this.baseFormGroup.get('BrojDana').updateValueAndValidity();
    }
  }

}
